"use strict";

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = function isEmpty(message) {
  return function (_ref) {
    var field = _ref.field;

    if (typeof field.value !== 'string') {
      return true;
    }

    var strVal = field && field.value && typeof field.value === 'string' ? field.value.trim() : field.value;

    var isEmpty = _validator.default.isEmpty(strVal);

    return [isEmpty, message || 'Please enter a value.'];
  };
};

var _default = isEmpty;
exports.default = _default;
//# sourceMappingURL=isEmpty.js.map